<ion-tabs #navTabs selectedIndex="0">
  <ion-tab-bar class="ion-align-items-center">
    <ion-tab-button *ngFor="let tab of tabs" tab="{{tab.page}}">
      <ion-icon name="{{tab.icon}}"></ion-icon>
      <ion-label>{{tab.name}}</ion-label>
    </ion-tab-button>
  </ion-tab-bar>
</ion-tabs>
